import http from "../../http-common";

class service {

  url = "/anagrafica/accessoutente";

  getAll() {
    return http.get(this.url);
  }

  get(id, params = {}) {
    return http.get(this.url + '/' + id, { params });
  }

  search(params) {
    return http.get(this.url + '/search', { params });
  }

  autocomplete(params) {
    return http.get(this.url + '/autocomplete', { params });
  }

  login(data) {
    return http.post("/anagrafica/auth/access_token", data);
  }

  recuperapsw(data) {
    return http.post("/anagrafica/auth/recuperapsw", data);
  }

  resetpsw(token, data) {
    return http.post("/anagrafica/auth/resetpsw?token=" + token, data);
  }

  me() {
    return http.get(this.url + "/me",);
  }

}

export default new service();